import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import useNuJobsStore from "../../../store/nujobs.store";
import { Form, Input, message, Button,Select } from "antd";

import "./nujobListingSearch.scss";
import { SUPPORTED_JOB_CATEGORY, SUPPORTED_LOCATION } from "../../../helper/categoryconstants";
import useNuJobDetailsStore from "../../../store/nujobsdetails.store";

export default function NuJobsJobListingsSearch({resultHandler, loggedIn}) {
  const navigate = useNavigate();

  const { getOSAllJds,nuJobsPendingSychMetaData } = useNuJobsStore();
  const { nujobsUserMetaDataStats } = useNuJobDetailsStore();
  const [form] = Form.useForm(); 
  const [formKey, setFormKey] = useState(1);
  useEffect(() => {
        if(loggedIn){
             const userData = JSON.parse(localStorage.getItem("nujobsUserDetails"));
             let encodedJsonValues ={};
             encodedJsonValues.nujuid= userData.nujuid   
             encodedJsonValues.nujoid= userData.nujoid
             encodedJsonValues.signedin= true
             encodedJsonValues.pendingsync = JSON.parse(
                localStorage.getItem("NuJobsPendingSync") || "[]"
            ); 
            nuJobsPendingSychMetaData(encodedJsonValues, nujobsUserMetaDataStats)               
        }    
  }, []);
 var initValues = {

  };
  const encodeJson = (values) =>{
        let encodedJsonValues ={};
        encodedJsonValues.keywords= values.keywords;
        encodedJsonValues.city=values.location;
        encodedJsonValues.category=values.category;  
        encodedJsonValues.timestamp= 0;  
        encodedJsonValues.postingdate= "All"
        encodedJsonValues.pagenum= 1;
        encodedJsonValues.maxPerPage= 10;

        //from values
        encodedJsonValues.minexp=null;
        encodedJsonValues.maxexp=null;  
        encodedJsonValues.minctc= null;  
        encodedJsonValues.maxctc= null
        encodedJsonValues.noticeperiod= []; 
        encodedJsonValues.postingdate=[];
        encodedJsonValues.workmode=null;  
        encodedJsonValues.diversity= null;  
        encodedJsonValues.role= []
        encodedJsonValues.roletype= []
        encodedJsonValues.companytype= null
        encodedJsonValues.jobfor= null  
        
        if(loggedIn){
            const userData = JSON.parse(localStorage.getItem("nujobsUserDetails"));
             encodedJsonValues.nujuid= userData.nujuid   
             encodedJsonValues.nujoid= userData.nujoid
             encodedJsonValues.signedin= true
             encodedJsonValues.pendingsync = JSON.parse(
                localStorage.getItem("NuJobsPendingSync") || "[]"
            );                
        }
        return encodedJsonValues
    }

    const handleFormSubmit = (values) => {
        const jasonValues = encodeJson(values)
        getOSAllJds(jasonValues,resultHandler)
      
    };  

  const handleChange = () => {};

  const getSearchReqParams = (similaryJds) => {
    return {
      location: similaryJds?.city,
      country: "India",
      keywords: similaryJds?.similarjds?.[0]?.keywords,
      category: similaryJds?.category
    }
}

  return (
    <div className="nujobListingSearch-wrapper">
       <div className="nujobListingSearch-title">
         <div className="nujobListingSearch-search-wrapper">
            <Form
                className="nujobListingSearch-search-wrapper"
                name="Search Form"
                autoComplete="off"
                onFinish={handleFormSubmit}
                form = {form}
                justify="start"
                key = {formKey}
                initialValues={initValues}                
            >
                <div className="nujobListing-search">
                    <Form.Item
                        name="keywords"
                    >
                        <Input
                            className="nujobListing-search-item"
                            type="text"
                            placeholder={"Company, Skills..."}
                        />
                    </Form.Item>
                    <Form.Item
                        name="location"
                    >
                            <Select
                                mode="multiple"
                                maxTagCount={2}
                                size="large"
                                placeholder={"Any Location"}
                                allowClear                             
                                required={ true}
                                className="nujobListing-search-item"                            
                                options={SUPPORTED_LOCATION}
                            />                         
                    </Form.Item>                    
                    <Form.Item
                        name="category"
                        rules={[{ required: true, message: 'Kindly Select at least one Category' }]}
                    >
                        <Select
                          mode="multiple"
                          maxTagCount={2}
                          size="large"
                          className="nujobListing-search-item"
                          allowClear          
                          placeholder="Any Category"
                          onChange={handleChange}
                          options={SUPPORTED_JOB_CATEGORY}
                        />                        
                    </Form.Item>  
                    <Form.Item
                        name="button"
                    >
                        <Button
                                className="nujobListing-search-button"
                                htmlType="submit"
                            >
                                Search Jobs
                        </Button>                        
                    </Form.Item>                      
                                        
                </div> 
                             
            </Form>
         </div>  
       </div>       
    </div>
  );
}
